import { render, staticRenderFns } from "./ClientBreadcrumb.vue?vue&type=template&id=b782009c"
import script from "./ClientBreadcrumb.vue?vue&type=script&lang=js"
export * from "./ClientBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports